module.exports = _.orderBy;


//////////////////
// WEBPACK FOOTER
// external "_.orderBy"
// module id = 421
// module chunks = business-manager/shoutout-popup business-manager/video-library-page shoutout/shoutout full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings